import { useEffect } from 'react'

/**
 * Hand-shared subscribe link. Orphaned by design — nothing in the nav, the
 * footer or any page links to /pay; it is a URL Garrett sends to a client
 * directly.
 *
 * NO PRICE IS DISPLAYED, deliberately. This page used to assert two different
 * ones: "Secure hosting and domain management, $50/month" in the prose and
 * "Subscribe for $25/month" on the button, on the same screen. Both were plain
 * literals, neither came from `@gjl/voice/pricing`, and they contradicted each
 * other — on the one page on the site that takes money.
 *
 * The obvious fix is to pick the right number and single-source it. That was
 * attempted and could not be done honestly: the Stripe payment link below is
 * hardcoded and does not appear in the account's payment_links list, so what it
 * actually charges cannot be verified from the codebase. The only active price
 * on the account is an unrelated per-client care plan. Displaying a price we
 * cannot source, next to a live checkout button, is worse than displaying none
 * — Stripe Checkout shows the real amount and billing interval before the
 * customer confirms.
 *
 * TO RESTORE A PRICE: confirm what the payment link charges, then render it from
 * a pricing accessor (e.g. `capabilityById('website')`) rather than a literal,
 * per docs/conventions/pricing.md. If the intent is the a-la-carte Website
 * capability, that accessor already holds the number.
 */
export default function PayPage() {
  useEffect(() => {
    document.title = 'Subscribe to Hosting | Fugue Lab'
  }, [])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4 text-center">
      <h1 className="mb-2 text-3xl font-bold">Subscribe to Hosting</h1>
      <p className="text-muted-foreground mb-6">Secure hosting and domain management for your site.</p>
      <a
        href="https://buy.stripe.com/4gMcN49ue4SkegWalWf3a00"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-primary text-primary-foreground hover:bg-primary/90 rounded px-6 py-2 transition-colors"
      >
        Subscribe
      </a>
      <p className="text-muted-foreground mt-4 text-sm">Price and billing interval are shown at checkout.</p>
    </div>
  )
}
